import imageDbHelper from "@/helpers/imageDbHelper";

export default {
    bind(el, binding) {
        const imageUrl = binding.value;
        if (!imageUrl) return;

        el.style.opacity = '0.5';
        el.style.transition = 'opacity 0.3s';

        const observer = new IntersectionObserver(async (entries) => {
            if (entries[0].isIntersecting) {
                observer.unobserve(el);

                const src = await imageDbHelper.fetchAndCacheImage(imageUrl);

                if (el.tagName === 'IMG') {
                    el.src = src;
                } else {
                    el.style.backgroundImage = `url(${src})`;
                }
                el.style.opacity = '1';
            }
        });

        observer.observe(el);
    }
};
